import { render } from "./DialogText.vue?vue&type=template&id=235c7085"
import script from "./DialogText.vue?vue&type=script&lang=js"
export * from "./DialogText.vue?vue&type=script&lang=js"

import "./DialogText.vue?vue&type=style&index=0&id=235c7085&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__